module.exports = __webpack_public_path__ + "img/collect_pic_25.a6506281.png";